import { ButtonIcon, Caption, DownloadIcon, Heading, HelpIcon, SyncIcon, Tooltip, WithSpaceProps } from 'canoe';
import React, { useState } from 'react';

import { TooltipPlacement } from 'canoe/components/Tooltip';
import TimeAgo from 'dashboard/components/TimeAgo';

interface TypographyProps {
  children: string;
}

export const PageTitle = ({ children }: TypographyProps) => (
  <Heading size="M" element="h1" m="none">
    {children}
  </Heading>
);

export const CardTitle = ({ children, mb }: TypographyProps & WithSpaceProps) => (
  <Heading size="XS" element="h2" mb={mb} strong>
    {children}
  </Heading>
);

export const CardSubtitle = ({ children }: { children: string | JSX.Element }) => (
  <Caption>{children}</Caption>
);

export const HelpTooltip = ({
  children,
  placement,
}: TypographyProps & { placement?: TooltipPlacement }) => (
  <Tooltip content={children} placement={placement}>
    <HelpIcon color="OnyxGrayL30" size="s" />
  </Tooltip>
);

export const DownloadTooltip = ({ onClick }: { onClick: () => Promise<void> }) => {
  const [isLoading, setLoading] = useState(false);
  const handleClick = async () => {
    setLoading(true);
    try {
      await onClick();
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  return (
    <Tooltip content="Download data">
      <ButtonIcon loading={isLoading} icon={DownloadIcon} onClick={handleClick} color="contrast" />
    </Tooltip>
  );
};

export const RefreshTooltip = ({
  date,
  onClick,
}: {
  date: number;
  onClick: () => Promise<void>;
}) => {
  const [isLoading, setLoading] = useState(false);
  const handleClick = async () => {
    setLoading(true);
    try {
      await onClick();
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  return (
    <Tooltip
      content={
        <div>
          <div>
            Last updated <TimeAgo date={date} />.
          </div>
          <div>Click to refresh.</div>
        </div>
      }
    >
      <ButtonIcon loading={isLoading} icon={SyncIcon} onClick={handleClick} color="contrast" />
    </Tooltip>
  );
};
